export default __webpack_public_path__ + "static/media/thaitue.de2ee374.png";